(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("onBoardingService", OnBoardingService);

    OnBoardingService.$inject = ['$q', 'userPermissions', 'brandServices', '$filter', 'hUser', '$state', 'hModalService', '$modal'];

    function OnBoardingService($q, userPermissions, brandServices, $filter, hUser, $state, hModalService, $modal) {
        var self = this;
        var settings = {};
        var userPositions = {};
        var users = {};
        var errorHandler = function (errors) {};
        var eventEmmiter = JarEventEmitter.call(self);
        var listDocuments = {};
        var isDoneEVerifyTest ;
        var applicationDocumentMetaCache = {};

        self.checkEVerifyExamStatus = function () {
            var defer = $q.defer();

            if (typeof isDoneEVerifyTest === 'boolean') {
                defer.resolve(isDoneEVerifyTest)
            } else {
                OnBoardingAPI.checkEVerifyExamStatus()
                    .then(function (status) {
                        isDoneEVerifyTest = (status === 'PASSED');
                        defer.resolve(isDoneEVerifyTest)
                    })
                    .catch(function (err) {
                        console.error(err)
                    });
            }

            return defer.promise;
        };

        self.clearOBDocumentsModalParams = function (prospect_id, application_id, showOBDocumentsModal, stateParams) {
            if (showOBDocumentsModal) {
                const currentUrl = new URL(window.location.href);
                const searchParams = currentUrl.searchParams;
                
                if (prospect_id) {
                    searchParams.delete('prospect_id');
                } else if (application_id) {
                    searchParams.delete('application_id');
                }

                searchParams.delete('showOBDocumentsModal');
                searchParams.delete('custom_type_name');
                searchParams.delete('custom_type_id');

                // Replace the current URL without triggering a navigation
                window.history.replaceState({}, '', `${currentUrl.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`);
            }
        };

        self.getProspects = function (prospects) {
            var prospectsWithoutHr = [];

            for (var prospectIndex in prospects) {
                var prospect = prospects[prospectIndex];
                var documents = prospect.documents || [];

                if (documents.length > 0) {

                    prospect.documents = prospect.documents.filter(function (document) {
                        return document.document_lookup ? document.document_lookup.category.code !== 'HR_ACTION' : true;
                    });

                    if (prospect.documents.length) {
                        prospectsWithoutHr.push(prospect);
                    }
                } else {
                    prospectsWithoutHr.push(prospect);
                }
            }
            return prospectsWithoutHr;
        };

        self.prepareSpeedyDocsData = function (ssIndex, memberData) {
            var defer = $q.defer();

            var prospectDocuments = [];
            var prospectResumes = {};

            memberData.prospects = self.getProspects(memberData.prospects) || [];

            memberData.commendationActions = [];
            memberData.disciplinaryActions = [];
            memberData.otherActions = [];

            var i9Documents = {};
            var usersPositions = [];
            var initPromises = {
                'policyParser': userPermissions.getBrandPolicy(memberData.brand.id),
            };

            initPromises['policyParser']
                .then(function (result) {
                    var hasManageArchivedLocationPermission = result.has(userPermissions.PERMISSIONS.ACCESS_CLOSED_LOCATIONS);
                    memberData.canManageWotcEligibility = result.has(userPermissions.PERMISSIONS.MANAGE_WOTC_ELIGIBILITY);
                    memberData.canTreminateAndRehireOnAtLeastOnePosition = result.has(userPermissions.PERMISSIONS.TERMINATE_REHIRE);

            var prePromises = {
                'onboardingBrand': self.getOnboardingBrand(memberData.brand.id, hasManageArchivedLocationPermission),
                'eVerifyExamStatus': self.checkEVerifyExamStatus(),
                'services': brandServices.checkAll(memberData.brand.id, [
                    brandServices.SERVICES.E_VERIFY,
                    brandServices.SERVICES.KEESING,
                    brandServices.SERVICES.RIGHT_TO_WORK,
                    brandServices.SERVICES.TRUST_ID_LITE,
                    brandServices.SERVICES.TRUST_ID_FULL,
                    brandServices.SERVICES.POS,
                    brandServices.SERVICES.POS_TOAST_SYNC,
                    brandServices.SERVICES.POS_ORACLE_SIMPHONY_SYNC,
                    brandServices.SERVICES.POS_BRINK_SYNC,
                    brandServices.SERVICES.PAYROLL,
                    brandServices.SERVICES.WOTC,
                    brandServices.SERVICES.HR_ACTIONS,
                    brandServices.SERVICES.TEAM_SCHEDULING,
                    brandServices.SERVICES.CORE_HR,
                ])
            };

            $q.all(prePromises)
                .then(function (result) {
                    memberData.isTrustIdFullServiceEnabled = result['services'][brandServices.SERVICES.TRUST_ID_FULL];
                    memberData.isWotcServiceEnabled = result['services'][brandServices.SERVICES.WOTC];
                    memberData.isTrustIdLiteServiceEnabled = result['services'][brandServices.SERVICES.TRUST_ID_LITE];
                    memberData.isTeamSchedulingServiceEnabled = result['services'][brandServices.SERVICES.TEAM_SCHEDULING];
                    memberData.isTrustIdServiceEnabled = memberData.isTrustIdFullServiceEnabled || memberData.isTrustIdLiteServiceEnabled;
                    memberData.isPosServiceEnabled = result['services'][brandServices.SERVICES.POS];
                    memberData.isToastSyncServiceEnabled = result['services'][brandServices.SERVICES.POS_TOAST_SYNC];
                    memberData.isOracleSimphonySyncServiceEnabled = result['services'][brandServices.SERVICES.POS_ORACLE_SIMPHONY_SYNC];
                    memberData.isBrinkSyncServiceEnabled = result['services'][brandServices.SERVICES.POS_BRINK_SYNC];
                    memberData.isKeesingEnabled = result['services'][brandServices.SERVICES.KEESING];
                    memberData.isRightToWorkEnabled = result['services'][brandServices.SERVICES.RIGHT_TO_WORK];
                    memberData.isEVerifyEnabled = result['services'][brandServices.SERVICES.E_VERIFY];
                    memberData.isPayrollEnabled = result['services'][brandServices.SERVICES.PAYROLL];
                    memberData.isHrActionsServiceEnabled = result['services'][brandServices.SERVICES.HR_ACTIONS];
                    memberData.isCoreHRServiceEnabled = result['services'][brandServices.SERVICES.CORE_HR];

                    memberData.brand.payroll_channel = result['onboardingBrand'].channel_code;
                    memberData.brandUserPayrollDisabled = result['onboardingBrand'].payroll_disabled;
                    memberData.isDoneEVerifyTest = result['eVerifyExamStatus'];

                    memberData.prospects.forEach(function (prospect, index) {
                        prospect.attachments = [];
                        if (prospect.start_date) {
                            prospect.start_date = moment.parseZone(prospect.start_date);
                        }
                        prospect.termination_documents = prospect.termination_documents || [];
                        prospect.customDocuments = {};
                        prospect.otherDocuments = prospect.otherDocuments || [];
                        prospect.resume = {};
                        prospect.application_documents = [];
                        prospect.isOnboardingAdmin = false;
                        prospect.hasSendToPayrollPermission = false;
                        prospect.canReviewI9Everify = false;
                        prospect.canResendI9WithOpenEverifyCase = false;
                        prospect.canSendToPOS = false;
                        prospect.canTerminateAndRehire = false;
                        prospect.canTerminateWithin30Days = false;
                        prospect.canManageCandidates = false;

                        userPermissions.getBrandPolicy(prospect.brand_id)
                            .then(function (policyParser) {
                                policyParser = policyParser.position(prospect.position.position_type.code, prospect.position.code);
                                prospect.isOnboardingAdmin = policyParser.hasAny(userPermissions.ONBOARDING);
                                prospect.canViewOnboarding = policyParser.hasAny(userPermissions.VIEW_ONBOARDING);
                                prospect.hasSendToPayrollPermission = policyParser.has(userPermissions.PERMISSIONS.SEND_TO_PAYROLL);
                                prospect.canManageCandidates = policyParser.has(userPermissions.PERMISSIONS.MANAGE_JOB_CANDIDATES);
                                prospect.canReviewI9Everify = policyParser.has(userPermissions.PERMISSIONS.I_9_REVIEW_AND_E_VERIFY);
                                prospect.canResendI9WithOpenEverifyCase = policyParser.has(userPermissions.PERMISSIONS.RESEND_I9_WITH_OPEN_EVERIFY_CASE);
                                prospect.canSendToPOS = policyParser.has(userPermissions.PERMISSIONS.SEND_TO_POS) || false;
                                prospect.canTerminateAndRehire = policyParser.has(userPermissions.PERMISSIONS.TERMINATE_REHIRE);
                                prospect.canTerminateWithin30Days = policyParser.has(userPermissions.PERMISSIONS.TERMINATE_WITHIN_30_DAYS);
                                prospect.viewDocsOnly = policyParser.has(userPermissions.PERMISSIONS.VIEW_ONBOARDING_DOCUMENTS);
                                prospect.canUploadDocs = policyParser.has(userPermissions.PERMISSIONS.UPLOAD_DOCUMENTS);
                                prospect.canSendToTrustId = policyParser.has(userPermissions.PERMISSIONS.SEND_TRUST_ID_CASE);

                                if (prospect.hiring_state == "HIRED") {
                                    memberData.show_payroll = true;
                                    memberData.show_send_to_pos = true;
                                    memberData.show_move_employee = true;
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });

                        self.returnDocumentFromListDocuments(OnBoardingAPI.DOCUMENT_TYPE.I9, null, prospect.id, null, null, null, true)
                            .then(function (aDocument) {
                                if (aDocument) {
                                    prospect.showI9FormFiller = true;
                                    prospect.document_set_code = aDocument.DocumentSet.code;
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });

                        var documents = [];
                        var otherDocuments = [];
                        var is_pending = false;
                        prospect.hasOffer = false;

                        var documentsMapById = {};
                        for (var documentIndex in prospect.documents) {
                            var mapDocument = prospect.documents[documentIndex];
                            documentsMapById[mapDocument.id] = mapDocument;
                            if (mapDocument.code ==='DOCUMENTS_CONTAINER') {
                                for (var subDocIndex in mapDocument.documents) {
                                    var mapSubDocument = mapDocument.documents[subDocIndex];
                                    documentsMapById[mapSubDocument.id] = mapSubDocument;
                                }
                            }
                        }

                        for (var documentsIndex in prospect.documents) {
                            var document = prospect.documents[documentsIndex];
                            if (document.code === 'DOCUMENTS_CONTAINER') {
                                for (var subDocIndex in mapDocument.documents) {
                                    var mapSubDocument = mapDocument.documents[subDocIndex];
                                    if (mapSubDocument.state !== OnBoardingAPI.appStatuses.APPROVED && mapSubDocument.state !== OnBoardingAPI.appStatuses.SIGNED && mapSubDocument.state !== OnBoardingAPI.appStatuses.CORRECTION_RESENT) {
                                        is_pending = true;
                                    }
                                }
                            }
                            else {
                                if (document.state !== OnBoardingAPI.appStatuses.APPROVED && document.state !== OnBoardingAPI.appStatuses.SIGNED && document.state !== OnBoardingAPI.appStatuses.CORRECTION_RESENT) {
                                    is_pending = true;
                                }
                            }
                            if (document.document_lookup && document.document_lookup.code) {
                                document.document_lookup.name = $filter("obDocName")(document.document_lookup.code, document.document_lookup.name, memberData.brand.document_set.code);
                            }

                            if (document.document_lookup && document.document_lookup.code === 'OFFER') {
                                prospect.hasOffer = true;
                            }


                            if (document.attachments) {
                                for (var attachmentIndex in document.attachments) {
                                    var userAttachment = document.attachments[attachmentIndex];

                                    userAttachment.attachment_code_lookup = userAttachment.attachment_code_lookup || {
                                        name: userAttachment.custom_name
                                    };

                                    userAttachment.name = userAttachment.attachment_code_lookup.name;
                                    userAttachment.code = userAttachment.attachment_code_lookup.code;

                                    if (['I9', 'I9_REVERIFICATION_SECTION_3', 'IDENTITY_DOCUMENT'].indexOf(document.document_lookup.code) === -1) {
                                        prospect.attachments.push(userAttachment);
                                    }
                                }
                            }

                            if (document.document_lookup) {
                                if (['POST_HIRE', 'END_OF_SERVICE'].indexOf(document.document_lookup.category.code) > -1) {
                                    prospect.termination_documents.push(document);
                                } else if (['BRAND_CUSTOM'].indexOf(document.document_lookup?.category?.code) > -1) {
                                    const subCategoryName = document.document_lookup?.subcategory?.name
                                    if (!prospect.customDocuments[subCategoryName]) {
                                        prospect.customDocuments[subCategoryName] = [document];
                                    } else {
                                        prospect.customDocuments[subCategoryName].push(document);
                                    }
                                } else if (['MINOR_WORK_DOCUMENTATION_WORK_PERMIT', 'MINOR_WORK_DOCUMENTATION_AGE_CERTIFICATE', 'MINOR_WORK_DOCUMENTATION'].indexOf(document.document_lookup.code) > -1 && !document.reference_document_id) {
                                    var documentIndex = _.findIndex(documents, function (d1) {
                                        return ['MINOR_WORK_DOCUMENTATION_WORK_PERMIT', 'MINOR_WORK_DOCUMENTATION_AGE_CERTIFICATE', 'MINOR_WORK_DOCUMENTATION'].indexOf(d1.document_lookup.code) > -1
                                    });

                                    if (documentIndex > -1) {
                                        documents[documentIndex].documentsList.push(document);
                                        if (document.document_lookup.code.startsWith('MINOR_WORK_DOCUMENTATION')) {
                                            otherDocuments.push(document)
                                        }
                                    } else {
                                        var newDoc = {
                                            id: document.id,
                                            document_lookup: {
                                                code: OnBoardingAPI.DOCUMENT_TYPE[document.document_lookup.code],
                                                name: OnBoardingAPI.DOC_TYPE_TEXT[document.document_lookup.code]
                                            },
                                            custom_name: OnBoardingAPI.DOC_TYPE_TEXT[document.document_lookup.code],
                                            expiration_date: document.expiration_date,
                                            documentsList: [document],
                                            file_name: document.file_name,
                                            updated: document.updated
                                        };
                                        documents.push(newDoc);
                                        if (document.document_lookup.code.startsWith('MINOR_WORK_DOCUMENTATION')) {
                                            otherDocuments.push(newDoc)
                                        }
                                    }
                                } else if ((OnBoardingAPI.CUSTOM_DOCUMENT_TYPES.indexOf(document.document_lookup.code) > -1 || OnBoardingAPI.CUSTOM_DOCUMENT_TYPES.includes(document.document_lookup?.category?.code)) && !document.reference_document_id) {
                                    otherDocuments.push(document);
                                } else if (document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9) {
                                    var i9IndexInDocumentList = _.findIndex(documents, function (d1) {
                                        return d1.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9;
                                    });

                                    if (memberData.isEVerifyEnabled) {
                                        document.everify_case_data = {
                                            brand: {
                                                id: memberData.brand.id,
                                                isDoneEVerifyTest: memberData.isDoneEVerifyTest
                                            },
                                            user: {
                                                id: memberData.user.id,
                                                first_name: memberData.user.first_name,
                                                last_name: memberData.user.last_name,
                                                cardId: ssIndex
                                            },
                                            prospect_id: prospect.id
                                        };
                                    }

                                    if (i9IndexInDocumentList > -1) {
                                        documents[i9IndexInDocumentList].documentsList.push(document);
                                        var documentListIndex = documents[i9IndexInDocumentList].documentsList.indexOf(document);

                                        i9Documents[document.id] = {
                                            documentIndex: i9IndexInDocumentList,
                                            prospectIndex: index,
                                            documentListIndex: documentListIndex
                                        };

                                    } else {
                                        var newI9Doc = {
                                            id: 'I9_DOCUMENT_' + document.id,
                                            document_lookup: {
                                                code: OnBoardingAPI.DOCUMENT_TYPE.I9,
                                                name: OnBoardingAPI.DOC_TYPE_TEXT[OnBoardingAPI.DOCUMENT_TYPE.I9]
                                            },
                                            documentsList: [document]
                                        };

                                        documents.push(newI9Doc);

                                        i9Documents[document.id] = {
                                            documentIndex: documents.indexOf(newI9Doc),
                                            prospectIndex: index,
                                            documentListIndex: 0
                                        };
                                    }
                                } else if ([OnBoardingAPI.DOCUMENT_TYPE.I9_REVERIFICATION_SECTION_3].indexOf(document.document_lookup.code) > -1) {
                                    self.manageI9reverificationDocument(document, documents, i9Documents, prospect, index);
                                } else if (document.reference_document_id) { // it is added after I9_REVERIFICATION_SECTION_3 check
                                    documentsMapById[document.reference_document_id] = documentsMapById[document.reference_document_id] || {};
                                    documentsMapById[document.reference_document_id].referenceDocuments = documentsMapById[document.reference_document_id].referenceDocuments || [];
                                    documentsMapById[document.reference_document_id].referenceDocuments.push(document);
                                } else if ([OnBoardingAPI.DOCUMENT_TYPE.RESUME].indexOf(document.document_lookup.code) > -1) {
                                    prospect.resume = document;
                                    prospectResumes[prospect.id] = document;
                                } else if ([OnBoardingAPI.DOCUMENT_TYPE.APPLICATION_DOCUMENT].indexOf(document.document_lookup.code) > -1) {
                                    prospect.application_documents.push(document);
                                } else if (document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT) {
                                    var identityDocumentIndex = _.findIndex(documents, function (d1) {
                                        return d1.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT;
                                    });

                                    if (identityDocumentIndex > -1) {
                                        documents[identityDocumentIndex].documentsList.push(document);
                                    } else {
                                        var newIdentityDoc = {
                                            id: 'IDENTITY_DOCUMENT_' + document.id,
                                            document_lookup: {
                                                code: OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT,
                                                name: OnBoardingAPI.DOC_TYPE_TEXT[OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT]
                                            },
                                            documentsList: [document]
                                        };
                                        documents.push(newIdentityDoc);
                                    }

                                    if (!prospect.employmentEligibility ||
                                        ((prospect.employmentEligibility && prospect.employmentEligibility.updated) &&
                                            (moment(document.updated).isAfter(moment(prospect.employmentEligibility.updated))))
                                    ) {
                                        prospect.employmentEligibility = {
                                            id: document.id,
                                            prospect_id: prospect.id,
                                            updated: document.state !== 'REQUESTED' ? document.updated : null,
                                            status: document.state,
                                            rtw_status: document.rtw_status,
                                            type: 'right_to_work',
                                            showTree: false,
                                        }
                                    }
                                } else {
                                    documents.push(document);
                                }
                            } else if (document.code ==='DOCUMENTS_CONTAINER') { // restructure documents group
                                var documentGroup = {
                                    id: document.code + "_" + prospect.id + "_" + documentsIndex,
                                    document_lookup: {
                                        code: OnBoardingAPI.DOCUMENT_TYPE.DOCUMENTS_CONTAINER,
                                        name: document.name
                                    },
                                    documentsList: document.documents
                                };
                                if (document.documents && document.documents.length && ['POST_HIRE', 'END_OF_SERVICE'].indexOf(document.documents[0].document_lookup.category.code) > -1) {
                                    prospect.termination_documents.push(documentGroup);
                                } else if (document.documents?.length && ['BRAND_CUSTOM'].indexOf(document.documents[0]?.document_lookup?.category?.code) > -1) {
                                    const subCategoryName = document.documents[0].document_lookup?.subcategory?.name
                                    if (!prospect.customDocuments[subCategoryName]) {
                                        prospect.customDocuments[subCategoryName] = [documentGroup];
                                    } else {
                                        prospect.customDocuments[subCategoryName].push(documentGroup);
                                    }
                                } else {
                                    documents.push(documentGroup);
                                }
                            }
                        }
                        if (documents[i9IndexInDocumentList]) {
                            documents[i9IndexInDocumentList].documentsList.filter(function (document) {
                                if (document.state === 'REQUESTED') {
                                    memberData.hasRequestedDoc = true
                                }
                            });
                        }

                        if (prospect.hiring_state === "HIRED") {
                            var moveEmployeePosition = angular.copy(prospect.position);
                            moveEmployeePosition.prospect_id = prospect.id;
                            usersPositions.push(moveEmployeePosition);
                        }

                        prospect.status = is_pending ? OnBoardingAPI.appStatuses.REQUESTED : OnBoardingAPI.appStatuses.APPROVED;
                        prospectDocuments = angular.copy(documents);
                        prospect.otherDocuments = angular.copy(otherDocuments);
                        prospect.otherDocuments = docsUtils.sortByDate(prospect.otherDocuments, 'updated');
                        prospect.documents = prospectDocuments;
                        memberData.resumes = prospectResumes;
                        var isAllMinor = function (doc) {
                            return doc.document_lookup.code.startsWith('MINOR_WORK_DOCUMENTATION');
                        }
                        if (prospect.otherDocuments.length) {
                            prospect.allMinor = prospect.otherDocuments.every(isAllMinor)
                        }
                    });
                    var innerPromises = {};
                    if (memberData.isHrActionsServiceEnabled && memberData.user.team_user_id) {
                        innerPromises['getUserActions'] = HumanResourceActionsAPI.getUserActions(memberData.brand.id, memberData.user.team_user_id)
                    }

                    $q.all(innerPromises)
                        .then(function (res) {
                            var actions = res['getUserActions'] || [];
                            if (actions && actions.length > 0) {
                                actions.forEach(function (action) {
                                    if (action.status !== 'DRAFT' && action.status !== 'PENDING_APPROVAL') {
                                        if (action.template.type === 'OTHER') {
                                            memberData.otherActions.push(action);
                                        } else if (action.template.type === 'COMMENDATION') {
                                            memberData.commendationActions.push(action);
                                        } else if (action.template.type === 'DISCIPLINARY') {
                                            memberData.disciplinaryActions.push(action);
                                        }
                                    }
                                });
                            }
                        })
                        .finally(function () {
                            defer.resolve({
                                data: memberData,
                                i9Documents: i9Documents
                            });
                        })
                })
                .catch(function (err) {
                    console.error(err);
                });
            }).catch(function (err) {
                console.error(err);
            });

            memberData.user.default_prospect = memberData.prospect_id;
            self.setUserDetails(memberData.user);
            self.setUserPositions(memberData.brand.id, memberData.user.id, usersPositions);
            return defer.promise;
        };

        self.prepareRTWDocumentsViewData  = function (rtwDocuments) {
            var documents = [];
            var is_pending = false;
            for (var documentsIndex in rtwDocuments) {
                var document = rtwDocuments[documentsIndex];

                document.document_lookup.name = $filter("obDocName")(document.document_lookup.code, document.document_lookup.name);

                if (document.attachments) {
                    for (var attachmentIndex in document.attachments) {
                        var userAttachment = document.attachments[attachmentIndex];

                        userAttachment.attachment_code_lookup = userAttachment.attachment_code_lookup || {
                            name: userAttachment.custom_name
                        };

                        userAttachment.name = userAttachment.attachment_code_lookup.name;
                        userAttachment.code = userAttachment.attachment_code_lookup.code;
                    }
                    document.attachmentsView = angular.copy(document.attachments);
                }

                if (document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT) {
                    var identityDocumentIndex = _.findIndex(documents, function (d1) {
                        return d1.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT;
                    });

                    if (identityDocumentIndex > -1) {
                        documents[identityDocumentIndex].documentsList = documents[identityDocumentIndex].documentsList || [];
                        documents[identityDocumentIndex].documentsList.push(angular.copy(document));
                        documents[identityDocumentIndex].documentsListView = angular.copy(documents[identityDocumentIndex].documentsList);
                    } else {
                        var newIdentityDoc = {
                            id: 'IDENTITY_DOCUMENT_' + document.id,
                            document_lookup: {
                                code: OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT,
                                name: OnBoardingAPI.DOC_TYPE_TEXT[OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT]
                            },
                            documentsList: [document],
                            documentsListView: angular.copy([document]),
                            prospect: document.prospect
                        };
                        documents.push(newIdentityDoc);
                    }
                } else {
                    documents.push(angular.copy(document));
                }
            }
            return documents;
        }

        self.DOCS_NEEDS_REVIEW = [
            OnBoardingAPI.DOCUMENT_TYPE.I9,
            OnBoardingAPI.DOCUMENT_TYPE.IRS_8850,
            OnBoardingAPI.DOCUMENT_TYPE.EMPLOYEE_STARTER,
            OnBoardingAPI.DOCUMENT_TYPE.RADISSON_EMEA_PERSONAL_LAUFZETTEL,
            OnBoardingAPI.DOCUMENT_TYPE.IRL_EMPLOYEE_STARTER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_VEHICLE_INSPECTION,
            OnBoardingAPI.DOCUMENT_TYPE.FARMERS_BOYS_EMPLOYEE_INFO,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_PERSONAL_OPT_OUT,
            OnBoardingAPI.DOCUMENT_TYPE.TATTU_RISK_ASSESSMENT_TRAINING_RECORD,
            OnBoardingAPI.DOCUMENT_TYPE.ROCKFISH_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.BOWERY_COMMUTER_BENEFITS,
            OnBoardingAPI.DOCUMENT_TYPE.WENDY_PERMIT_TO_EMPLOY,
            OnBoardingAPI.DOCUMENT_TYPE.AHH_NIGHT_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.AHH_EMPLOYMENT_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.TATTU_FOOD_HANDLER_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.CONDITIONAL_EMPLOYEE_INTERVIEW,
            OnBoardingAPI.DOCUMENT_TYPE.RADISSON_SWITZERLAND_PERSONAL_LAUFZETTEL,
            OnBoardingAPI.DOCUMENT_TYPE.RADISSON_PERSONALSTAMMBLATT_AT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.TATTU_TRAINING_HEALTH_SAFETY_BOOKLET,
            OnBoardingAPI.DOCUMENT_TYPE.FOOD_HANDLERS_HEALTH_DECLARATION,
            OnBoardingAPI.DOCUMENT_TYPE.HARRYS_DOLCI_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.GRANARY_SQUARE_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.EAST_COAST_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.FRANKIE_BENNY_MONITORING_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.GUACHO_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.BKUK_WORKING_TIME_OPT_OUT,
            OnBoardingAPI.DOCUMENT_TYPE.PIZZA_PILGIRMS_OPT_OUT,
            OnBoardingAPI.DOCUMENT_TYPE.BRASSERIE_BAR_WORKING_TIME_REGULATION,
            OnBoardingAPI.DOCUMENT_TYPE.LITTLE_GEMS_FOOD_HANDLERS_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.ABC_BENEFIT_ELECTION_SWIPE_N_SAVE,
            OnBoardingAPI.DOCUMENT_TYPE.GUACHO_COVID_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.REV_419_EX_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_STORE_APPROVAL_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.GUACHO_TIME_OPT_OUT,
            OnBoardingAPI.DOCUMENT_TYPE.CHARLES_EMPLOYEE_DETAILS_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.AT_STAFF_ACCEPTANCE_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.JEAN_GEORGES_HEALTH_INSURANCE_WAIVER_DOUBLE,
            OnBoardingAPI.DOCUMENT_TYPE.MERAKI_STARTER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.WORKS_INCOME_TAX,
            OnBoardingAPI.DOCUMENT_TYPE.LORE_HOTELS_PERSONAL_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.LORE_PERSONAL_DETAILS_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.ACADEMY_HS_INDUCTION_PACK_RARE,
            OnBoardingAPI.DOCUMENT_TYPE.JERSY_MIKE_DIRECT_DEPOSIT,
            OnBoardingAPI.DOCUMENT_TYPE.CIRRUS_INNS_PERSONAL_DETAILS,
            OnBoardingAPI.DOCUMENT_TYPE.LDV_EMPLOYMENT_APPLICATION,
            OnBoardingAPI.DOCUMENT_TYPE.ISLAND_POKE_EMPLOYEE_STARTER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.GOTHAM_BENEFIT_INFORMATION_DOUBLE,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.CG_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.SCHEDULE_AVAILABILITY_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.DAVES_CHICKEN_ARBITRATION_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_AIO_INSIDER,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_AIO_DRIVER_MANAGER,
            OnBoardingAPI.DOCUMENT_TYPE.COMPASSIONATE_CARE_FULL_OB,
            OnBoardingAPI.DOCUMENT_TYPE.WAHACA_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.JAMES_HEALTH_ASSESSMENT,
            OnBoardingAPI.DOCUMENT_TYPE.HOME_HOUSE_HEALTH_ASSESMENT,
            OnBoardingAPI.DOCUMENT_TYPE.WISELY_WAGE_PAYMENT,
            OnBoardingAPI.DOCUMENT_TYPE.STREET_GUYS_COMMUTER_BENEFITS,
            OnBoardingAPI.DOCUMENT_TYPE.LA_OWCA,
            OnBoardingAPI.DOCUMENT_TYPE.AT_PERSONAL_DETAILS_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.ABC_HEALTH_BENEFITS_WAIVER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.HARTS_EMPLOYEE_STARTER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD,
            OnBoardingAPI.DOCUMENT_TYPE.KRICKET_STARTER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.BISCUITEERS_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.DC_COMMUTER_BENEFITS,
            OnBoardingAPI.DOCUMENT_TYPE.FARMER_BOYS_MEAL_WAIVER_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.COMMUTER_BENEFITS_DOUBLE,
            OnBoardingAPI.DOCUMENT_TYPE.COMMUTER_BENEFITS_DOUBLE_NJ,
            OnBoardingAPI.DOCUMENT_TYPE.IRL_DOUBLE_EMPLOYMENT_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.STATE_W_AL,
            OnBoardingAPI.DOCUMENT_TYPE.HOUSE_CAFE_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.BELFRY_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.JERSY_MIKE_EMPLOYEE_AUTHORIZATION,
            OnBoardingAPI.DOCUMENT_TYPE.BRASSERIE_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.THE_RESTAURANT_MEDICAL_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_STATEMENT_OF_WORK,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.FARMER_BOYS_LOF_MEAL_WAIVER,
            OnBoardingAPI.DOCUMENT_TYPE.FARMER_BOYS_IRIS_MEAL_WAIVER
        ];

        self.DOCS_WITHOUT_PREVIEW_WITH_CONDITION= [
            OnBoardingAPI.DOCUMENT_TYPE.GET_FOOD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_SWEDEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.YOUNGS_LIVE_IN_OUT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SHOOT_THE_BULL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_BATH_BUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ADVENTURE_PARC_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SQUARE_GRILL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_NETHERLANDS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_ITALY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AZUMI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BVLGARI_HOTEL_LONDON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.APOS_ACCOMMODATION_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.ALMOND_FAMILY_PUBS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_ACCOMMODATION_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.WESTBEACH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AHH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BOCCA_DI_LUPO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_APOSTROPHE_GM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_PIZZA_POT_GM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.QUBIC_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.QBIC_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CUBITT_HOUSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CUBITT_HOUSE_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FMI_CA_DISPUTE_RESOLUTION,
            OnBoardingAPI.DOCUMENT_TYPE.SF_CITY_OPTION_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.MCD_PROGRESSIVE_DISCIPLINARY_ACTION_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.YO_SUSHI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TATTU_RISK_ASSESSMENT_TRAINING_RECORD,
            OnBoardingAPI.DOCUMENT_TYPE.MARRIOTT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BEDS_BARS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CRAFT_LOCALS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RUM_KITCHEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ISLAND_POKE_NEW_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PING_PONG_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STICK_SUSHI_CHANGE_EMPLOYMENT_AFLOSER,
            OnBoardingAPI.DOCUMENT_TYPE.STICK_SUSHI_CHANGE_EMPLOYMENT_HOURS_SALARY,
            OnBoardingAPI.DOCUMENT_TYPE.FAZENDA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FAZENDA_HEAD_OFFICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SAN_CARLO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_LETTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_NEW_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_STATEMENT_OF_WORK,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.WRIGHT_BROTHERS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_NEWT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HAWKSMOOR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BERKELEY_INNS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HAWKSMOOR_EDINBURGH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HALAL_GUYS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GOLD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WINGSTOP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BISTROTHEQUE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.UPHAM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BUBALA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.YO_SUSHI_TEAM_MEMBER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.REZIDOR_PENSION_SCHEME,
            OnBoardingAPI.DOCUMENT_TYPE.REZIDOR_BLU_EXECUTIVE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.REZIDOR_JERSEY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.REZIDOR_JERSEY_EXECUTIVE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.REZIDOR_PARK_EXECUTIVE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DIRTY_BONES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PETERSHAM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PREZZO_RESTAURANT_TEAM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PREZZO_SUPPORT_CENTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WYNDHAM_GRAND_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CSDK_COE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DD_LONDON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DD_HEAD_OFFICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.JOB_DESCRIPTION,
            OnBoardingAPI.DOCUMENT_TYPE.POSITION_DOCS,
            OnBoardingAPI.DOCUMENT_TYPE.PREZZO_SUPPORT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GRAND_BRIGHTON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PREZZO_RESTAURANT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PREZZO_RESTAURANT_NEW_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PREZZO_HOURLY_STANDARD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ETM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BURGERS_COCKTAILS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BURGERS_COCKTAILS_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LANCASTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WYBOSTON_LAKES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LANCASTER_EVENTS_OP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LANCASTER_FB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LANCASTER_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NOTICE_EMPLOYEE_NY,
            OnBoardingAPI.DOCUMENT_TYPE.CAFUA_NOTICE_OF_PAY,
            OnBoardingAPI.DOCUMENT_TYPE.EMILY_ESTATE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BELFRY_NOMINATION_OF_BENEFICIARY,
            OnBoardingAPI.DOCUMENT_TYPE.NOTICE_EMPLOYEE_GENERAL,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_GELON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_GENHQ_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BURGER_LOBSTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BURGER_LOBSTER_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GOODMANS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GOODMANS_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LANDMARK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STATE_W_DISPATCHER,
            OnBoardingAPI.DOCUMENT_TYPE.TENPIN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TENPIN_SUPPORT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HONEST_BURGERS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CINNAMON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SLIM_CHICKENS_NEW_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARLUCCIOS_NEW_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DARK_KITCHEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIZZA_PILGRIMS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIZZA_PILGRIMS_CHILD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIZZA_PILGRIMS_CHILD_WITH_TRONC_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HONEST_BURGERS_HEAD_OFFICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ANDREW_BROWNSWORD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ZETTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARLUCCIOS_N_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ANDREW_BROWNSWORD_ACCOMMODATION,
            OnBoardingAPI.DOCUMENT_TYPE.THE_BATH_PRIORY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AT_HEALTH_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.LANSDOWNE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KBK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SMF_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ARABICA_BOROUGH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DAVES_TWC_INSURANCE_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.ARABICA_FOOD_SPICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ARABICA_FOOD_LIMTED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ARABICA_KX_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VAGABOND_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RED_CAT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ART_CLUB_DUBAI_LETTER_OF_INTENT,
            OnBoardingAPI.DOCUMENT_TYPE.VAGABOND_HQ_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EGGSLUT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RARE_BIRD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEV_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TAMATANGA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BOSTON_TEA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NZR_GROUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.IBERICA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WULF_LAMB_CONTRACT_AMENDMENT,
            OnBoardingAPI.DOCUMENT_TYPE.WULF_LAMB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BERBERE_ITALY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ARCHIES_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KOH_THAI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PARK_INN_NORTHAMPTON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_QCC_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ARCHIES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NOTICE_OF_HOURS_REDUCTION_JUST_CAUSE,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_ZERO_HOUR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_JERSEY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_GUERNSEY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_GROUP_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_GROUP_JERSEY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIBERATION_GROUP_GUERNSEY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_TEAM_MEMBER_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_AGM_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.FARM_GIRL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.OVER_UNDER_COFFEE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HALL_WOODHOUSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SISBAN_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.URBAN_FRESH_BURGERS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COACHING_INN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COACHING_INN_CO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ANNABELS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BIRLEY_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARRYS_BAR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GASTRONOMY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BIMS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HERTFORD_5_STREET_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.YARD_SALE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DISCOVERY_ADVENTURE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BART_TAYLOR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BEEFY_BOYS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KNOOPS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.JULIENNE_BRUNO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BLOOMSBURY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BOO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRUNCHCO_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NURST_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_NEW_FEDERAL_REG_TIPPED,
            OnBoardingAPI.DOCUMENT_TYPE.QFM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ZOOM1HR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RITZ_LONDON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARLUCCIOS_DAWSON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CROCUS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CROCUS_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DARJEELING_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EPOCH_GROUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PAN_PACIFIC_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.POPEYES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PALL_MALL_67_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DONER_SUMMER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NNA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CHIKN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BTG_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EPOCH_GROUP_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ROMET_GROUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HAUS_HOLDNIG_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HAUS_HOLDNIG_N_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BAKER_HOSPITALITY_THE_SUN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BAKER_HOSPITALITY_CHURCH_STREET_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BISTROTHEQUE_PROPERTY_ISSUE_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.ARCHIES_STAFF_EQUIPMENTS_CHECKLIST,
            OnBoardingAPI.DOCUMENT_TYPE.THE_GOOD_EGG_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NOTICE_OF_HOURS_REDUCTION_ECONOMIC_REASON,
            OnBoardingAPI.DOCUMENT_TYPE.NICI_HOTELS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ALLBRIGHT_OPERATION_CONTRACT ,
            OnBoardingAPI.DOCUMENT_TYPE.ALLBRIGHT_CENTRAL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EDIN_HOTELS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIANO_WORKS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARTS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.YOTEL_NETHERLANDS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARTS_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SUMMER_OPS_EMPLOYEE_NOTICE,
            OnBoardingAPI.DOCUMENT_TYPE.OLE_STEEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ABSOLUTE_TASTE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.JERSY_MIKE_NEW_HIRE,
            OnBoardingAPI.DOCUMENT_TYPE.KRICKET_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BLACKLOCK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FLOR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARLUCCIOS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIEMINISTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIEMINISTER_ALL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BACKGROUND_GROUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CDG_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CDG_MANAGER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.YOTEL_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CDG_TEAM_MEMBER_2_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CDG_CONCESSIONS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_SPAIN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_DENMARK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VILAGE_EAST_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RIDING_HOUSE_CAFE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RAILHOUSE_CAFE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RIDING_HOUSE_CAFE_HQ_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BARACK_HOLDINGS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_GREENFIELDS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FIRMDALE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RAREBIRDS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BIG_EASY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_SO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_RESTAURANTS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HONEST_BURGERS_CONTRACT_HOURLY_ONLY,
            OnBoardingAPI.DOCUMENT_TYPE.ASCOTT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MAWGLI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_LOWRY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_OPT_OUT,
            OnBoardingAPI.DOCUMENT_TYPE.KERB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DEEP_BLUE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BIRD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ART_CLUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AOK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WAGAMAMA_MANAGER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AUBAINE_UNIFORM_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.LDV_ARBITRATION_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.WINGMANS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WAGAMAMA_HEAD_OFFICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WAGAMAMA_TEAM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ART_CLUB_CONTRACT_JUNIOR,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BREAKFAST_CLUB_CONTRACT_HOURLY,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_RESTAURANT_MERGED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_RESTAURANT_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.JACKSON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIMEYARD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_COLLECTION_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BOXPARK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_MARKET_GRILL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BKUK_UNIFORM_ORDER,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_COLLECTION_BRASSERIE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRASSERIE_LIGHT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARRYS_DOLCI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BLACK_SHEEP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.XP_FACTORY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GREYHOUND_CAFE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BLACK_SHEEP_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GRANARY_SQUARE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_COLLECTION_GM_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_COLLECTION_GM_SALARIED_2_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_COLLECTION_BRASSERIE_GM_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BARTLETT_MITCHELL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.INAMO_KEY_FOB_RESPONSIBILITY_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.BRASSERIE_LIGHT_GM_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARRYS_DOLCI_GM_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GRANARY_SQUARE_GM_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WORKERS_COMPENSATION_NOTICE_CA,
            OnBoardingAPI.DOCUMENT_TYPE.CAPRICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KANADA_YA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COAL_KITCHEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HOME_HOUSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HOME_HOUSE_HG_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MARKET_HALL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_IRELAND_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TRISHNA_TRONC_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.HUMBLE_GRAPE_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HUMBLE_GRAPE_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MB_MEDICAL_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.TIME_OF_HIRE_PAMPHLET_CA,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_DUBLIN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LIVELYHOOD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GYMBOX_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GIRAFFE_STOP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GIRAFFE_STOP_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EDS_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EDS_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GIRAFFE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.JP_RESTAURANTS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ROCKFISH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEAHORSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ROCKFISH_CASUAL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ROCKFISH_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GIRAFFE_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GC_MALLEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.M_RESTAURANT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SOURCED_MARKET_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RICK_STEIN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RICK_STEIN_CONTRAC_V2,
            OnBoardingAPI.DOCUMENT_TYPE.EAST_COAST_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KITOPI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RECEIPT_ACK_EMPLOYEE_HANDBOOK,
            OnBoardingAPI.DOCUMENT_TYPE.MELROSE_MORGAN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MEGANS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SENOR_CEVICHE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KOREAN_DINNER_PARTY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MERCATO_METROPOLITANO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HQ_THEATER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COMPASSIONATE_CARE_COMMUNITY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MERCATO_METROPOLITANO_N_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COMPASSIONATE_CARE_SUPPORT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COMPASSIONATE_CARE_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BARONS_EDEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FARMER_J_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GRINDCO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GRINDCO_SUPPORT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HERTFORD_STREET_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_WAVE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRINDISA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRINDISA_GM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRINDISA_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STICK_SUSHI_DE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STICK_SUSHI_FLEX_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STICK_SUSHI_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KFC_DEMIPOWER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KFC_DEMIPOWER_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KFC_DEMIPOWER_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RICHMOND_HILL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_IVY_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_IVY_TEAM_MEMBER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CAPRICE_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CAPRICE_TEAM_MEMBER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BALTHAZAR_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BALTHAZAR_TEAM_MEMBER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WENDY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KFC_RSC_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VECTOR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CHEESE_BAR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KRICKET_TRONC_INVITE,
            OnBoardingAPI.DOCUMENT_TYPE.SLIM_CHICKENS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MUSTARD_CATERING_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SLIM_CHICKENS_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BLEECKER_BURGER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.LUXURY_FAMILY_HOTELS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_BELFRY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ST_JAMES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ST_JAMES_SJH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MICHAEL_CAINES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PAPA_JOHNS_GB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.INCIPIO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SAMBA_TRONC_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.THE_PAROGON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FUGGLES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ST_AUSTELL_BREWERY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BADIANI_1932_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EAT_PITTA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEFTON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.NOBLE_INNS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WH_380_E_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.NOBLE_INNS_TRONC_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.GRIND_TRONC_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.LANGAN_CHUCS_TRONC_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_HO_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.SHIVA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SCARPETTA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_HO_HOURLY_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.BURGER_KING_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BROTHER_MARCUS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEASONS_SEAHAM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VARIOS_EATERIES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEASONS_OPERATIONS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEASONS_SALES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CHILLED_PUBS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MKD_HOLDINGS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CHESTERFORD_FISH_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STICK_SUSHI_ONBOARDING_FISH,
            OnBoardingAPI.DOCUMENT_TYPE.CHESTERFORD_GROUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VE_RARE_BIRD_HOTELS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BILLS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BILLS_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RED_ENGINE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CENTURION_CONTACT,
            OnBoardingAPI.DOCUMENT_TYPE.BROTHER_MARCUS_TRONC_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.GENTLEMEN_BARISTAS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SUPERMARKET_OF_DREAMS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FULLER_SMITH_TURNER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTSWOLD_FARM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TATTU_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.KITCHEN_VENTURES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BONE_DADDIES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TAPATAPA_CONTACT,
            OnBoardingAPI.DOCUMENT_TYPE.BODMIN_JAIL_HOTEL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.EAST_LONDON_PUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TATTU_AGE_VERIFICATION_POLICY,
            OnBoardingAPI.DOCUMENT_TYPE.CAL_SAVERS_OPT_OUT,
            OnBoardingAPI.DOCUMENT_TYPE.ROTIKING_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_WORKS_EIRE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_WORKS_ISLE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_WORKS_NIR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_WORKS_UK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_WORKS_UK_PROMOTION_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FIGHT_CLUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ELECTRIC_SHUFFLE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FIGHT_CLUB_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SAVOY_MEDICAL_QUESTIONNAIRE,
            OnBoardingAPI.DOCUMENT_TYPE.CHALKPIT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.STRADA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ST_JAMES_IMOLOTT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SABOR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BONE_BURGER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRASSERIE_BAR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEASONS_STARTER_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.ACE_HOTEL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THUNDERBIRD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MONTE_FORTE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BISTROT_PIERRE_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BISTROT_PIERRE_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BISTROT_PIERRE_GM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BRASSERIE_BAR_TEAM_MEMBER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ARCADE_THEATRE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.THE_CONDUIT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RC_GROUP_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARAVAN_CCR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARAVAN_GM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CARAVAN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VEL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VARIOUS_EATERIES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SWAN_INN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COUNTRY_CREATURES_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.TOMAHAWK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.URBAN_LEISURE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BIRLEY_CLUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FLAT_IRON_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.PIZZA_HUT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SHEPHERD_NEAME_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GALETA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MJMK_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.B_TOGETHER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GUESTHOUSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WEBBER_TIP_CREDIT_NOTICE,
            OnBoardingAPI.DOCUMENT_TYPE.CJB_TERMS_CONDITIONS_OF_EMPLOYMENT,
            OnBoardingAPI.DOCUMENT_TYPE.CHEQUERS_INN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WATCH_HOUSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WATCH_HOUSE_HO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BKUK_CHANGE_OF_DETAILS,
            OnBoardingAPI.DOCUMENT_TYPE.COPPA_CLUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VINOTECA_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COPPA_CLUB_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CG_WORKING_TIME_REGULATION,
            OnBoardingAPI.DOCUMENT_TYPE.BELOW_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEAC_CONSENT_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.VURGER_CO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WILTON_HOLDINGS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FRANCO_HOLDINGS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BELOW_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AUBAINE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AUBAINE_FRANCAIS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.AUBAINE_SUPPORT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GAUCHO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GAUCHO_HEAD_OFFICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WR_LINA_STORE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.WR_KYMS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MERAKI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.DISHOOM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MULINO_PERSONAL_INFO,
            OnBoardingAPI.DOCUMENT_TYPE.LORE_HOTELS_PERSONAL_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.LORE_PERSONAL_DETAILS_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.MIGUELS_UNIFORM_AUTHORIZATION,
            OnBoardingAPI.DOCUMENT_TYPE.WELLS_CO_TIPS_DECLARATION,
            OnBoardingAPI.DOCUMENT_TYPE.IVY_DAWOSN_OFFER_LETTER,
            OnBoardingAPI.DOCUMENT_TYPE.CIRRUS_INNS_PERSONAL_DETAILS,
            OnBoardingAPI.DOCUMENT_TYPE.ARTIST_RESIDENCE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GRABTHAI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_MANAGED_HOUSE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_APOSTROPHE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_PIZZA_POT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_MASTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_MASTER_WEEKLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_MASTER_MONTHLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_MANAGED_HOUSE_SALARIED_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CW_MANAGED_HOUSE_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FRONTIER_PUBS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MAGNOLIA_PAY_RATE_NOTICE,
            OnBoardingAPI.DOCUMENT_TYPE.MULINO_ACK_PAY_RATE_NY,
            OnBoardingAPI.DOCUMENT_TYPE.MULINO_ACK_PAY_RATE_IL,
            OnBoardingAPI.DOCUMENT_TYPE.LITTLE_GEMS_ACCOMMODATION_AGREEMENT,
            OnBoardingAPI.DOCUMENT_TYPE.DRAKE_MORGAN_EMPLOYMENT_CONFIRMATION,
            OnBoardingAPI.DOCUMENT_TYPE.HARRY_RAMSDEN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARRY_RAMSDEN_IRELAND_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARRY_RAMSDEN_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARRY_RAMSDEN_EU_HOURLY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ISLAND_POKE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.HARBOUR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FISHWORKS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FISHWORKS_CHILDREN_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GBK_CENTRAL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GBK_UK_RESTAURANT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GBK_IR_RESTAURANT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GBK_MANAGEMENT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CG_TUTTONS_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CG_FIRE_STONE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CG_DIRTY_MARTINI_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CG_HEAD_OFFICE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.CUBITT_HOUSE_SET_TRONC,
            OnBoardingAPI.DOCUMENT_TYPE.CUBITT_HOUSE_VARIANCE_TRONC,
            OnBoardingAPI.DOCUMENT_TYPE.INAMO_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RED_CARNATION_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_GERMANY_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BUNDOBUST_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VILLAGE_HOTELS_TM_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VILLAGE_HOTELS_HOD_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEAFOOD_PUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.SEAFOOD_BAR_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.FOLIE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.BIG_SMOKE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.MORGAN_PUB_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.VQ_RESTAURANT_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.ROYAL_LANCASTER_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.GENERATOR_FRANCE_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.RED_CARNATION_ADDITIONAL_DOCS,
            OnBoardingAPI.DOCUMENT_TYPE.BLAKENEY_HOTEL_CONTRACT,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_RESTAURANT_MANAGER_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_RESTAURANT_HOURLY_ALL_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.COTE_RESTAURANT_HOURLY_CONTRACTS,
            OnBoardingAPI.DOCUMENT_TYPE.NZR_GROUP_UNIFORM_EQUIPMENT_ISSUE_FORM,
            OnBoardingAPI.DOCUMENT_TYPE.CHESTERFORD_JOY_BRAND_CONTRACT
        ];

        self.getOnboardingBrandSettings = function (brandId) {
            var defer = $q.defer();

            if (settings[brandId]) {
                defer.resolve(settings[brandId]);
            } else {
                OnBoardingAPI
                    .getOnboardingBrandSettings(brandId)
                    .then(function (brandSettings) {
                        settings[brandId] = brandSettings;
                        defer.resolve(settings[brandId]);
                    }, function (error) {
                        errorHandler(error);
                        defer.reject(error);
                    });
            }

            return defer.promise;
        };

        self.getUsersPositions = function (brandId, usersIds) {

            var result = {};

            for (var i in usersIds) {
                var userId = usersIds[i];

                if (userPositions[brandId] && userPositions[brandId][userId]) {
                    result[userId] = userPositions[brandId][userId];
                }
            }

            return result;
        };

        self.filterWageMatrixRules = (allWageRules, docPayType) => {
            return allWageRules.filter(rule => {
                const isCompensationRateMatch = rule.pay_types.some(rulePayType => {
                    if (docPayType === 'PER_HOUR') {
                        return rulePayType.type === 'HOURLY';
                    }
                    if (docPayType === 'PER_YEAR') {
                        return rulePayType.type === 'SALARIED';
                    }
                    return false;
                });

                return isCompensationRateMatch;
            });
        }

        self.handleNoticeWageMatrixBulkSend = (failedProspects) => {
            const defer = $q.defer();
            const groupedProspects = failedProspects.reduce((acc, current) => {
                const reason = current.reason;
                const userName = `${current.prospect.user.first_name} ${current.prospect.user.last_name}`;
                if (!acc[reason]) {
                    acc[reason] = [];
                }
                acc[reason].push(userName);
                return acc;
            }, {});
            $modal({
                controller: 'WageMatrixFailedProspectsModalController',
                controllerAs: '$ctrl',
                templateUrl: '../modules/on_boarding/modals/wage-matrix-failed-prospects/wage-matrix-failed-prospects.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: () => {
                        return {
                            prospectsDetails: groupedProspects
                        };
                    },
                    onClose: () => {
                        return () => {
                            defer.resolve(OnBoardingAPI.WAGE_MATRIX.CLOSE_WAGE_CONFIRMATION_MODAL);
                        };
                    }
                }
            });
            return defer.promise;
        }

        self.getNoticeOfHirePositionAndBirthDates = (prospectsDetails, formData, user) => {
            let positionCode = '';
            let birthDates = [];
            let isBulkSend = false;

            if (prospectsDetails?.length > 0) {
                if (prospectsDetails.length === 1) {
                    positionCode = prospectsDetails[0].position.code;
                    birthDates = new Date(prospectsDetails[0].birthdate);
                } else {
                    isBulkSend = true;
                    positionCode = prospectsDetails
                        .filter(p => p.birthdate)
                        .map(p => p.position.code)
                        .join(',');

                    birthDates = prospectsDetails
                        .filter(p => p.birthdate)
                        .map(p => new Date(p.birthdate));
                }
            } else {
                positionCode = formData.OBIdObj?.job?.Position?.code || formData.OBIdObj?.position?.code;
                birthDates = formData?.OBIdObj?.birthdate && new Date(formData.OBIdObj.birthdate);
            }

            return {
                positionCode: positionCode,
                birthDates: birthDates,
                isBulkSend: isBulkSend
            };
        };

        self.getAppliedWageRulesDetails = (birthDate, wageRules, isBulk) => {
            const todayDate = new Date();
            let appliedWageRules = [];

            const calculateAge = (birthDate) => {
                const birthDateObj = new Date(birthDate);
                let age = todayDate.getFullYear() - birthDateObj.getFullYear();
                const month = todayDate.getMonth() - birthDateObj.getMonth();
                if (month < 0 || (month === 0 && todayDate.getDate() < birthDateObj.getDate())) {
                    age--;
                }
                return age;
            }

            let ages;
            let age;
            if (birthDate) {
                if (isBulk) {
                    ages = birthDate.map(birthDate => calculateAge(birthDate));
                } else {
                    age = calculateAge(birthDate);
                }

                // Filter applied wage rules based on age and effective date
                appliedWageRules = wageRules.map(rule => {
                    const effectiveFromDate = new Date(rule.effective_from);
                    const matchingRates = rule.wage_rule_rates.filter(rate => {
                        if (Utils.isValidNumber(rate.from_age) && Utils.isValidNumber(rate.to_age)) {
                            if (isBulk) {
                                return ages.every(age => age >= rate.from_age && age < rate.to_age);
                            } else {
                                return age >= rate.from_age && age < rate.to_age;
                            }
                        } else {
                            return true;
                        }
                    });
                    if (todayDate >= effectiveFromDate && matchingRates.length > 0) {
                        return {
                            ...rule,
                            wage_rule_rates: matchingRates
                        };
                    } else {
                        return null;
                    }
                }).filter(rule => rule !== null);
            } else {
                appliedWageRules = wageRules;
            }

            let effectiveWageRule = null;
            let effectiveWageRuleHasAgeRange = false;
            let minWageRate = null;
            let maxWageRate = null;

            // Determine the effective wage rule and the min/max wage rates
            if (appliedWageRules.length === 1) {
                effectiveWageRule = appliedWageRules[0];
            } else if (appliedWageRules.length > 1) {
                effectiveWageRule = appliedWageRules.reduce((prevRule, currentRule) => {
                    const prevEffectiveDate = new Date(prevRule.effective_from);
                    const currentEffectiveDate = new Date(currentRule.effective_from);
                    return currentEffectiveDate > prevEffectiveDate ? currentRule : prevRule;
                });
            }

            if (effectiveWageRule) {
                effectiveWageRuleHasAgeRange = effectiveWageRule.wage_rule_rates.some(rate => Utils.isValidNumber(rate.from_age));
                if (!birthDate && effectiveWageRuleHasAgeRange) {
                    effectiveWageRule = null;
                    appliedWageRules = null;
                }
            }

            if (effectiveWageRule) {
                const effectiveWageRuleRate = effectiveWageRule.wage_rule_rates.reduce((prevRate, currentRate) => {
                    return currentRate.from_rate > prevRate.from_rate ? currentRate : prevRate;
                });
                minWageRate = effectiveWageRuleRate.from_rate;
                maxWageRate = effectiveWageRuleRate?.to_rate;
            }

            return {
                age: age,
                ages: ages,
                minWageRate: minWageRate,
                maxWageRate: maxWageRate,
                appliedWageRules: appliedWageRules,
                effectiveWageRule: effectiveWageRule,
                effectiveWageRuleHasAgeRange: effectiveWageRuleHasAgeRange
            };
        }

        self.getUserDetails = function (userId) {
            return users[userId];
        };

        self.setUserDetails = function (user) {
            users[user.id] = user;
        };

        self.setUserPositions = function (brandId, userId, userPositionsLoaded) {
            userPositions[brandId] = userPositions[brandId] || {};
            userPositions[brandId][userId] = userPositionsLoaded;
        };

        self.moveEmployeesToAnotherPosition = function (brandId, prospects) {
            var defer = $q.defer();

            OnBoardingAPI
                .moveEmployeeFromPositionToPosition(brandId, prospects)
                .then(function (res) {
                    defer.resolve(res);
                }, function (error) {
                    errorHandler(error);
                    defer.reject(error);
                });

            return defer.promise;
        };

        self.getBrandsMoveTo = function (brandId, offset, limit, filterByName) {
            var defer = $q.defer();

            var types = ['enterprise', 'child'];
            var services = ['ON_BOARDING'];

            BrandAPI
                .getFlattedBrandsTreeSearch(brandId, types, services, offset, limit, filterByName)
                .then(function (brands) {
                    defer.resolve(brands);
                }, function (error) {
                    errorHandler(error);
                    defer.reject(error);
                });

            return defer.promise;
        };

        self.moveEmployeeLocation = function (brandId, toBrandId, prospects) {
            var defer = $q.defer();

            OnBoardingAPI
                .moveEmployeeFromProspectToLocation(brandId, toBrandId, prospects)
                .then(function (res) {
                    defer.resolve(res);
                }, function (error) {
                    errorHandler(error);
                    defer.reject(error);
                });

            return defer.promise;
        };

        var userGroupsCache = {};
        var userBrandsCache = {};

        self.getOnboardingBrand = function (brandId, includeArchived) {
            var defer = $q.defer();

            if (userBrandsCache[brandId]) {
                defer.resolve(angular.copy(userBrandsCache[brandId]));
            }
            else {
                self.loadOnboardingBrands(brandId, includeArchived)
                    .then(function () {
                        if (userBrandsCache[brandId]) {
                            defer.resolve(angular.copy(userBrandsCache[brandId]));
                        }
                        else {
                            defer.reject("Couldn't get brand details:", brandId);
                        }
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.loadOnboardingBrands = function (groupId, includeArchived) {
            var defer = $q.defer();

            if (userGroupsCache[groupId] && includeArchived === null) {
                defer.resolve(angular.copy(userGroupsCache[groupId]));
            }
            else {
                OnBoardingAPI.loadBrands(groupId, includeArchived)
                    .then(function (brands) {
                        userGroupsCache[groupId] = brands;

                        for (var i in brands) {
                            userBrandsCache[brands[i].id] = brands[i];
                        }

                        defer.resolve(angular.copy(userGroupsCache[groupId]));
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.manageI9reverificationDocument = function (document, documents, i9Documents, prospect, prospectIndex) {
            var i9IndexInDocumentList = _.findIndex(documents, function (d1) {
                return d1.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9;
            });

            if (i9IndexInDocumentList > -1) {
                var documentListIndex;

                if (document.reference_document_id) {
                    for (var docIndex in prospect.documents) {
                        var doc = prospect.documents[docIndex];

                        if (doc.document_lookup?.code === OnBoardingAPI.DOCUMENT_TYPE.I9 && doc.id === document.reference_document_id && i9Documents[doc.id]) {
                            var appendToIndex = i9Documents[doc.id].documentListIndex;
                            documents[i9IndexInDocumentList].documentsList[appendToIndex].referenceDocuments = documents[i9IndexInDocumentList].documentsList[appendToIndex].referenceDocuments || [];
                            documents[i9IndexInDocumentList].documentsList[appendToIndex].referenceDocuments.push(document);
                            break;
                        }
                    }
                } else {
                    documents[i9IndexInDocumentList].documentsList.push(document);
                }

                documentListIndex = documents[i9IndexInDocumentList].documentsList.indexOf(document);

                i9Documents[document.id] = {
                    documentIndex: i9IndexInDocumentList,
                    prospectIndex: prospectIndex,
                    documentListIndex: documentListIndex
                };

            } else {
                var newI9Doc = {
                    id: 'I9_DOCUMENT_' + document.id,
                    document_lookup: {
                        code: "I9",
                        name: "Employment Eligibility (I9)"
                    },
                    documentsList: [document]
                };

                documents.push(newI9Doc);

                i9Documents[document.id] = {
                    documentIndex: documents.indexOf(newI9Doc),
                    prospectIndex: prospectIndex,
                    documentListIndex: 0
                };
            }
        };


        self.trigger = function (event, action, response) {
            eventEmmiter.trigger(event, action, response);
        };

        self.init = function (brandId) {

            return $q.all([
                self.getOnboardingBrandSettings(brandId),
            ]);
        };

        self.listDocuments = function(appId, prospectId, category, userId, includeNoTemplateDocuments, includeAllDocuments, lookupCode, actionId) {
            var defer = $q.defer();

            let uniqueKey = JSON.stringify([appId, prospectId, category, userId, includeNoTemplateDocuments, includeAllDocuments, lookupCode, actionId]);

            OnBoardingAPI.listDocuments(appId, prospectId, category, userId, includeNoTemplateDocuments, includeAllDocuments, lookupCode, actionId)
                .then(function (res) {
                    listDocuments[uniqueKey] = res;
                    defer.resolve(angular.copy(listDocuments[uniqueKey]));
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.returnDocumentFromListDocuments = function(documentType, appId, prospectId, category, userId, includeNoTemplateDocuments, includeAllDocuments, lookupCode) {
            var defer = $q.defer();

            //includeAllDocuments must be true
            self.listDocuments(appId, prospectId, category, userId, includeNoTemplateDocuments, includeAllDocuments, lookupCode)
                .then(function (listDocuments) {
                    var aDocument;
                    for (var i in listDocuments) {
                        var tempDocument = listDocuments[i];
                        if (documentType === tempDocument.code) {
                            aDocument = tempDocument;
                            break;
                        }
                    }
                    defer.resolve(aDocument);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };


        self.getApplicationDocumentLastMeta = (brandId, documentCode, prospectId, appId, forceNoCache, isSigningAsCandidate) => {
            var defer = $q.defer();
            var cardId = prospectId || appId;
            if (applicationDocumentMetaCache[cardId + '_' + documentCode] && !forceNoCache) {
                defer.resolve(angular.copy(applicationDocumentMetaCache[cardId + '_' + documentCode]));
            } else {

                if (!hUser.isEmployer() || isSigningAsCandidate) {
                    OnBoardingAPI.getLastDocMeta(documentCode)
                        .then(function (documentMeta) {
                            applicationDocumentMetaCache[cardId + '_' + documentCode] = documentMeta || {};
                            defer.resolve(angular.copy(applicationDocumentMetaCache[cardId + '_' + documentCode]));
                        }).catch(function (err) {
                        defer.resolve({});
                    });
                } else {
                    OnBoardingAPI.getApplicationDocumentLastMeta(brandId, documentCode, prospectId, appId)
                        .then(function (documentMeta) {
                            applicationDocumentMetaCache[cardId + '_' + documentCode] = documentMeta.meta_data || {};
                            defer.resolve(angular.copy(applicationDocumentMetaCache[cardId + '_' + documentCode]));
                        }).catch(function (err) {
                        defer.resolve({});
                    });
                }
            }

            return defer.promise;
        };

        self.prefillDocumentFields = function (brandId, fields, prospectId, appId, isSigningAsCandidate) {
            var defer = $q.defer();
            var promises = {};
            var data = {};
            var fromI9_W4_EmployeeStarter = ['EMPLOYEE_NAME', 'EMPLOYEE_DATE_OF_BIRTH', 'EMPLOYEE_PHONE_NUMBER', 'EMPLOYEE_EMAIL_ADDRESS', 'EMPLOYEE_ADDRESS' ]
            var fromOffer = ['EMPLOYMENT_START_DATE', 'EMPLOYMENT_ISSUE_DATE', 'EMPLOYMENT_JOB_TITLE', 'EMPLOYMENT_WEEKLY_WORKING_HOURS', 'EMPLOYMENT_SALARY_AMOUNT', 'EMPLOYMENT_PAYING_FREQUENCY', 'EMPLOYER_SUPERVISOR_NAME', 'EMPLOYER_SUPERVISOR_TITLE' ];


            for (var i in fromI9_W4_EmployeeStarter) {
                var field = fromI9_W4_EmployeeStarter[i];
                if (fields.indexOf(field) > -1) {
                    promises['I9'] =  self.getApplicationDocumentLastMeta(brandId, OnBoardingAPI.DOCUMENT_TYPE.I9, prospectId, appId, false, isSigningAsCandidate);
                    promises['W4'] =  self.getApplicationDocumentLastMeta(brandId, OnBoardingAPI.DOCUMENT_TYPE.W4, prospectId, appId, false, isSigningAsCandidate);
                    promises['EmployeeStarter'] =  self.getApplicationDocumentLastMeta(brandId, OnBoardingAPI.DOCUMENT_TYPE.EMPLOYEE_STARTER, prospectId, appId, false, isSigningAsCandidate);
                    break;
                }
            }
            for (var i in fromOffer) {
                var field = fromOffer[i];
                if (fields.indexOf(field) > -1 && hUser.isEmployer()) {
                    promises['OFFER'] =  self.getApplicationDocumentLastMeta(brandId, OnBoardingAPI.DOCUMENT_TYPE.OFFER, prospectId, appId, false, isSigningAsCandidate) || '';
                    break;
                }
            }

            $q.all(promises)
                .then(function (result) {
                    var i9Meta = result.I9 && result.I9 || {};
                    var w4Meta = result.W4 && result.W4 || {};
                    var employeeStarterMeta = result.EmployeeStarter && result.EmployeeStarter || {};
                    var offerMeta = result.OFFER && result.OFFER || {};

                    for (var i in fields) {
                        var field = fields[i];

                        switch (field) {
                            case "EMPLOYER_USER_NAME" :
                                if (hUser.isEmployer()) {
                                    data[field] = hUser.data.user.first_name + " " + hUser.data.user.last_name;
                                } else {
                                    data[field] = offerMeta.employer_name || '';
                                }
                                break;
                            case "EMPLOYMENT_START_DATE" :
                                data[field] = offerMeta.start_date || '';
                                data[field] = data[field] ? new Date(data[field]).setHours(12) : '';
                                break;
                            case "EMPLOYMENT_ISSUE_DATE" :
                                data[field] = new Date();
                                data[field] = new Date(data[field]).setHours(12);
                                break;
                            case "EMPLOYMENT_JOB_TITLE" :
                                data[field] = offerMeta.position_name || '';
                                break;
                            case "EMPLOYMENT_WEEKLY_WORKING_HOURS" :
                                data[field] = offerMeta.hours_per_week || '';
                                break;
                            case "EMPLOYMENT_SALARY_AMOUNT" :
                                data[field] = parseFloat(offerMeta.salary) || '';
                                break;
                            case "EMPLOYMENT_PAYING_FREQUENCY" :
                                var frequency = '';
                                if (offerMeta.compensation === "PER_HOUR") {
                                    frequency = "Per hour";
                                } else if (offerMeta.compensation === "PER_YEAR") {
                                    frequency = "Per year";
                                } else if (offerMeta.compensation === "PER_WEEK") {
                                    frequency = "Per week";
                                } else if (offerMeta.compensation === "PER_MONTH") {
                                    frequency = "Per month";
                                }
                                data[field] = frequency;
                                break;

                            case "EMPLOYER_SUPERVISOR_NAME" :
                                data[field] = offerMeta.supervisor_name || '';
                                break;
                            case "EMPLOYER_SUPERVISOR_TITLE" :
                                data[field] = offerMeta.supervisor_title || '';
                                break;
                            case "EMPLOYEE_NAME" :
                                var name = '';
                                var personalInfo = i9Meta.personal_information || w4Meta.personal_information || employeeStarterMeta.personal_information;
                                if (personalInfo) {
                                    name = personalInfo.middle_initial ? personalInfo.first_name + ' ' + personalInfo.middle_initial + ' ' +  personalInfo.last_name : personalInfo.first_name + ' ' + personalInfo.last_name;
                                } else {
                                    if (!hUser.isEmployer()) {
                                        name = hUser.data.user.first_name + " " + hUser.data.user.last_name;
                                    }
                                }
                                data[field] = name;
                                break;
                            case "EMPLOYEE_DATE_OF_BIRTH" :
                                var birthdate = '';
                                var personalInfo = i9Meta.personal_information || w4Meta.personal_information || employeeStarterMeta.personal_information;
                                if (personalInfo) {
                                    birthdate = personalInfo.birth_date || personalInfo.birthdate;
                                } else {
                                     if (!hUser.isEmployer()) {
                                         birthdate= hUser.data.user.birth_date || '';
                                     }
                                }
                                data[field] = birthdate;
                                data[field] = data[field] ? new Date(data[field]).setHours(12) : '';
                                break;
                            case "EMPLOYEE_PHONE_NUMBER" :
                                var phone = '';
                                var personalInfo = i9Meta.personal_information || w4Meta.personal_information || employeeStarterMeta.personal_information;
                                if (personalInfo) {
                                    phone = personalInfo.phone;
                                }
                                else {
                                    if (!hUser.isEmployer()) {
                                        phone = hUser.data.user.phone || '';
                                    }
                                }
                                data[field] = phone;
                                break;

                            case "EMPLOYEE_EMAIL_ADDRESS" :
                                var email = '';
                                var personalInfo = i9Meta.personal_information || w4Meta.personal_information || employeeStarterMeta.personal_information;
                                if (personalInfo) {
                                    email = personalInfo.email;
                                }
                                else {
                                    if (!hUser.isEmployer()) {
                                        email = hUser.data.user.email || '';
                                    }
                                }
                                data[field] = email;
                                break;

                            case "EMPLOYEE_ADDRESS" :
                                var address = '';
                                var personalInfo = i9Meta.personal_information || w4Meta.personal_information || employeeStarterMeta.personal_information;
                                if (personalInfo) {
                                    var address_line1 = personalInfo.address || '';
                                    var address_line2 = personalInfo.apartment || '';
                                    var town_city = personalInfo.town_city || '';
                                    var post_code = personalInfo.post_code || '';
                                    address = address_line1 + "," + ((address_line2) ? address_line2 + ", " : " ") + ((town_city) ? town_city + ", " : " ") + post_code;
                                } else {
                                    if (!hUser.isEmployer()) {
                                        var address_line1 = hUser.data.user.address || '';
                                        var address_line2 = hUser.data.user.apartment || '';
                                        var post_code = hUser.data.user.post_code || hUser.data.user.zip_code || '';
                                        address = ((address_line1) ? address_line1 + ", " : " ") + ((address_line2) ? address_line2 + ", " : " ") + post_code;
                                    }
                                }
                                data[field] = address;
                                break;
                        }
                    }

                    defer.resolve(data);
                });

            return defer.promise;
        };

        self.getDocumentLookupUploadUrl = function (documentId, lookupId, fileName) {
            var defer = $q.defer();
            OnBoardingAPI
                .getDocumentLookupUploadUrl(documentId, lookupId, fileName)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });
            return defer.promise;
        }

        self.uploadDocumentLookup = function (documentId, lookupId, data) {
            var defer = $q.defer();
            OnBoardingAPI
                .uploadDocumentLookup(documentId, lookupId, data)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });
            return defer.promise;
        }

        self.getSelectedOptions = function (field) {
            var optionsValues = [];
            field.options.options.forEach(function (option) {
                if (option.checked) {
                    optionsValues.push(option.value);
                }
            });
            return optionsValues;
        };

        self.getNeededDataForDocResend = function(OBIdObj) {
            var defer = $q.defer();
            var prospectId = OBIdObj.document.prospect_id;
            var appId = OBIdObj.document.application_id;
            var userId = OBIdObj.user.id;
            var brandId = OBIdObj.brand.id;

            var promises = {
                'userInfo': MemberAPI.getMemberInfoByAppIdOrProspectId(appId, prospectId),
                'isTeamEnabled': brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId),
            };

            if (prospectId) {
                promises['userProfileDetails'] = OnBoardingAPI.getBrandProspectsByIds(brandId, [prospectId]);
            } else {
                promises['userProfileDetails'] = OnBoardingAPI.getBrandProspectsByIds(brandId, [], [appId]);
            }

            $q.all(promises)
                .then(function (result) {
                    var userProfileDetails = result && result.userProfileDetails.prospects && result.userProfileDetails.prospects[0].user;
                    var isTeamEnabled = result['isTeamEnabled'];
                    var obIdObj = [];
                    obIdObj[0] = {
                        candidate_id: userId,
                        positions: [OBIdObj.job.Position],
                        position: OBIdObj.job.Position,
                        brand_id: brandId,
                        name: OBIdObj.user.first_name + ' ' + OBIdObj.user.last_name,
                        prospect_id: OBIdObj.document.prospect_id,
                        candidate_fname: OBIdObj.user.first_name,
                        candidate_lname: OBIdObj.user.last_name,
                        isTeamEnabled: isTeamEnabled,
                        job_id: OBIdObj.job.id || '',
                        candidate_email: userProfileDetails.email,
                        source: "MY_DOCS"
                    };

                    defer.resolve({
                        userDetails: result['userInfo'],
                        updatedOBIdObj: obIdObj
                    });
                })
                .catch(function (err) {
                    console.error(err)
                });

            return defer.promise;
        };

        self.getStateWithholdingCode = function(allDocs) {
            var stateWithholdingCode;

            for (var i in allDocs) {
                if (allDocs[i].code.includes("STATE_W") && allDocs[i].Document && (allDocs[i].Document.state == "SIGNED" || allDocs[i].Document.state == "APPROVED")) {
                    stateWithholdingCode = allDocs[i].code;
                }
            }

            return stateWithholdingCode;
        };

        var getFormsMetaData = (brandId, prospectId, appId, documentCode, isSigningAsCandidate) => {
            var defer = $q.defer();
            var promises = {};
            var data = {};

            if (documentCode) {
                promises['lastMeta'] = self.getApplicationDocumentLastMeta(brandId, documentCode, prospectId, appId, true, isSigningAsCandidate);
            }
            promises['I9'] = self.getApplicationDocumentLastMeta(brandId, OnBoardingAPI.DOCUMENT_TYPE.I9, prospectId, appId, true, isSigningAsCandidate);
            promises['W4'] = self.getApplicationDocumentLastMeta(brandId, OnBoardingAPI.DOCUMENT_TYPE.W4, prospectId, appId, true, isSigningAsCandidate);

            if (prospectId) {
                promises['userInfo'] = OnBoardingAPI.getBrandProspectsByIds(brandId, [prospectId]);
            } else {
                promises['userInfo'] = OnBoardingAPI.getBrandProspectsByIds(brandId, [], [appId]);
            }

            $q.all(promises)
                .then(function (result) {
                    var lastMeta = result && result.lastMeta;
                    var i9Meta = result && result.I9;
                    var w4Meta = result && result.W4;
                    var userInfo = result && result.userInfo.prospects && result.userInfo.prospects[0].user;

                    if (!_.isEmpty(lastMeta)) {
                        data.doc_last_meta = lastMeta;
                    }
                    if (!_.isEmpty(i9Meta)) {
                        data.i9_meta = i9Meta;
                    }
                    if (!_.isEmpty(w4Meta)) {
                        data.w4_meta = w4Meta;
                    }
                    if (!_.isEmpty(userInfo)) {
                        data.user_info = userInfo;
                    }

                    defer.resolve(data);
                });

            return defer.promise;
        };

        self.getMismatchFields = function (i9Meta, w4Meta, documentMeta, userProfileInfo, compareAddress) {
            var data = {};
            var personalInformationFields = ['first_name', 'last_name', 'birthdate', 'ssn', 'phone', 'email'];
            var personalInformationFieldsWithAddress = ['first_name', 'last_name', 'birthdate', 'ssn', 'phone', 'email', 'address' ,'apartment', 'city', 'county', 'zip_code', 'state'];
            var caseInSensitiveFields = ['first_name', 'last_name', 'address','apartment','city','county', 'email'];
            var mismatchFieldsList = [];
            var formsMeta = [];
            var i9MetaPersonalInfo = i9Meta && i9Meta.personal_information;
            var w4MetaPersonalInfo = w4Meta && w4Meta.personal_information;
            var documentMetaPersonalInfo = {};
            if (documentMeta) {
                if (documentMeta.candidate && !!documentMeta.candidate.first_name && !!documentMeta.candidate.last_name) {
                     documentMetaPersonalInfo =  documentMeta.candidate;
                } else {
                    documentMetaPersonalInfo = documentMeta.personal_information;
                }
            }

            if (!_.isEmpty(documentMetaPersonalInfo)) {
                for (var key in documentMetaPersonalInfo) {
                    if (documentMetaPersonalInfo.hasOwnProperty(key)) {
                        if (key === 'tin') {
                            documentMetaPersonalInfo['ssn'] = documentMetaPersonalInfo['tin'];
                        }
                        if (key === 'phone_number') {
                            documentMetaPersonalInfo['phone'] = documentMetaPersonalInfo['phone_number'];
                        }
                        if (key === 'cell_phone') {
                            documentMetaPersonalInfo['phone'] = documentMetaPersonalInfo['cell_phone'];
                        }
                        if (key === 'birth_date') {
                            documentMetaPersonalInfo['birthdate'] = documentMetaPersonalInfo['birth_date'];
                        }
                    }
                }
            }

            i9MetaPersonalInfo = angular.copy(i9MetaPersonalInfo);
            documentMetaPersonalInfo = angular.copy(documentMetaPersonalInfo);
            w4MetaPersonalInfo = angular.copy(w4MetaPersonalInfo);
            var userInfo = angular.copy(userProfileInfo);
            if (w4MetaPersonalInfo || documentMetaPersonalInfo) {
                formsMeta = [{info:w4MetaPersonalInfo, code: 'W4'}, {info:documentMetaPersonalInfo, code: 'STATE_W'}];
            }

            userInfo['birthdate'] = userInfo['birth_date'];
            userInfo['phone'] = userInfo['phone'] && userInfo['phone'].replace(/ /g, '').replace(/-/g, "").slice(-10);

            if (i9MetaPersonalInfo) {
                var state = i9MetaPersonalInfo.state;
                state = state && convertBetweenStateAndAbbreviation(state, false);
                i9MetaPersonalInfo.state = state;

                var phone = i9MetaPersonalInfo.phone;
                phone = phone && phone.replace(/ /g, "").replace(/-/g, "");
                i9MetaPersonalInfo.phone = phone;

                if (i9MetaPersonalInfo.birthdate) {
                    var birthdate = i9MetaPersonalInfo.birthdate;
                    birthdate = birthdate && moment(birthdate).format("YYYY-MM-DD");
                    i9MetaPersonalInfo.birthdate = birthdate;
                }

                if(i9MetaPersonalInfo.ssn_applied) {
                    i9MetaPersonalInfo.ssn = "";
                }

                for (var i in caseInSensitiveFields) {
                    var field = caseInSensitiveFields[i];
                    if (i9MetaPersonalInfo && i9MetaPersonalInfo[field]) {
                        i9MetaPersonalInfo[field] = i9MetaPersonalInfo[field].toLowerCase().trim();
                    }
                }
            }

            if (formsMeta.length) {
                formsMeta.forEach(function (form) {
                    if (form && form.info){
                        var ssn = form.info.ssn;
                        ssn = ssn && ssn.replace(/ /g, "").replace(/-/g, "");
                        form.info.ssn = ssn;

                        if(form.info.ssn_applied) {
                            form.info.ssn = "";
                        }

                        if (form.info.birthdate) {
                            var birthdate = form.info.birthdate;
                            birthdate = birthdate && moment(birthdate).format("YYYY-MM-DD");
                            form.info.birthdate = birthdate;
                        }

                        if (form.info.phone) {
                            var phone = form.info.phone;
                            phone = phone && phone.replace(/ /g, "").replace(/-/g, "");
                            form.info.phone = phone;
                        }
                    }
                    var fields = [];
                    if (compareAddress) {
                        if (form.code === 'W4') {
                            fields = personalInformationFieldsWithAddress;
                        } else {
                            fields = personalInformationFields;
                        }
                    } else {
                        fields = personalInformationFields;
                    }

                    for (var i in fields) {
                        var field = fields[i];
                        if (caseInSensitiveFields.includes(field)) {
                            if (form?.info?.[field] !== undefined && form?.info?.[field] !== null) {
                                form.info[field] = form.info[field].toLowerCase().trim();
                            }
                        }
                        if (form.code === 'STATE_W' && form && form.info && (form.info[field] === "" || form.info[field] === null)) {
                            delete form.info[field];
                        }

                        if (form && form.info && form.info[field] !== undefined && (i9MetaPersonalInfo && i9MetaPersonalInfo[field] !== undefined && i9MetaPersonalInfo[field] !== form.info[field])) {
                            data.w4OrStateWithholdingMismatch = true;
                            if (!mismatchFieldsList.includes(field)) {
                                mismatchFieldsList.push(field);
                            }
                        }
                    }
                });
            }

            for (var i in personalInformationFields) {
                var field = personalInformationFields[i];
                if (caseInSensitiveFields.includes(field)) {
                    if (userInfo[field] && userInfo[field] !== undefined) {
                        userInfo[field] = userInfo[field].toLowerCase().trim();
                    }
                }

                if (field == 'birthdate') {
                    if (userInfo[field]) {
                        userInfo[field] = moment(userInfo[field]).format("YYYY-MM-DD");
                    }
                }

                if (userInfo[field] !== undefined && (i9MetaPersonalInfo && i9MetaPersonalInfo[field] !== userInfo[field])) {
                    data.userMismatch = true;
                    if (!mismatchFieldsList.includes(field)) {
                        mismatchFieldsList.push(field);
                    }
                }
            }

            data.mismatch_fields_list = mismatchFieldsList;

            return data;
        };

        var getMismatchFieldsDetails = function (missMatchFieldsList, i9Meta, w4Meta, userInfo) {
            var res = {};
            for (var i in missMatchFieldsList) {
                var field = missMatchFieldsList[i];

                res[field] = {
                    i9: i9Meta && i9Meta.personal_information[field] || '',
                    w4: w4Meta && w4Meta.personal_information[field] || '',
                    userProfile: userInfo && userInfo[field]
                }
                if (field === 'birthdate') {
                    res[field].userProfile = userInfo && userInfo['birth_date'];
                }

                if (res[field].i9 !== res[field].w4) {
                    res[field].hasW4Missmatch = true;
                }
                if (res[field].i9 !== res[field].userProfile) {
                    res[field].hasUserInfoMismatch = true
                }
            }
            return res;
        }

        self.checkMismatchFields = (brandId, prospectId, appId, documentCode, isSigningAsCandidate) => {
            var defer = $q.defer();
            var promises = {};
            var res = {};

            promises['metaDataInfo'] = getFormsMetaData(brandId, prospectId, appId, documentCode, isSigningAsCandidate);

            $q.all(promises)
                .then(function (result) {
                    var info = result && result.metaDataInfo;
                    var i9Meta = info.i9_meta;
                    var w4Meta = info.w4_meta;
                    var docMeta = info.doc_last_meta;
                    var userInfo = info.user_info;

                    res = self.getMismatchFields(i9Meta, w4Meta, docMeta, userInfo, true);
                    res.w4Signed = w4Meta ? true : false;
                    res.stateWithholdingSigned = docMeta ? true : false;
                    res.i9Meta = i9Meta;
                    res.w4Meta = w4Meta;

                    if (res.mismatch_fields_list.length >= 1) {
                        res.mismatch_fields_details = getMismatchFieldsDetails(res.mismatch_fields_list, i9Meta, w4Meta, userInfo);
                    }
                    if (res.mismatch_fields_list.length > 0) {
                        var mismatchFieldsNames = "";
                        var hasNameMismatch = false;
                        var hasAddressMismatch = false;
                        var fieldsNamesMapping = {
                            'birthdate':'Date of Birth',
                            'ssn':'Social Security Number',
                            'phone':'Phone Number',
                            'email':'Email Address',
                        };

                        res.mismatch_fields_list.forEach(function (field) {
                            if (field === 'first_name' || field === 'last_name') {
                                hasNameMismatch = true;
                                return;
                            }
                            if (field === 'address' || field === 'apartment' || field === 'city' || field === 'county' || field === 'state' || field === 'zip_code') {
                                hasAddressMismatch = true;
                                return;
                            }
                            mismatchFieldsNames += fieldsNamesMapping[field] + ', ';
                        });

                        if (hasNameMismatch) {
                            mismatchFieldsNames = 'Name'  + ', ' + mismatchFieldsNames;
                        }

                        if (hasAddressMismatch) {
                            mismatchFieldsNames += 'Address'  + ', ';
                        }

                        mismatchFieldsNames = mismatchFieldsNames && mismatchFieldsNames.slice(0, -2);
                        res.mismatchFieldsNames = mismatchFieldsNames;
                    }

                    if (res.mismatch_fields_list.length > 0) {
                        for (var field of res.mismatch_fields_list) {
                            res.w4Meta && res.w4Meta.personal_information && (res.w4Meta.personal_information[field] = '');
                        }
                    }

                    defer.resolve(res);
                });

            return defer.promise;
        };

        self.checkMismatchAndPrefillPersonalInfo = function (brandId, prospectId, appId, documentCode) {
            var defer = $q.defer();
            var promises = {};
            var res = {};
            var documentsCodeWithPhoneField = ['STATE_W_OK','STATE_W_MN', 'STATE_W_NY', 'STATE_W_HI', 'STATE_W_MD', 'STATE_W_CA', 'STATE_W_DISPATCHER'];
            var documentsCodeWithEmailField = ['STATE_W_NY', 'STATE_W_HI', 'STATE_W_CA'];

            promises['metaDataInfo'] = getFormsMetaData(brandId, prospectId, appId, documentCode, true);

            $q.all(promises)
                .then(function (result) {
                    var info = result && result.metaDataInfo;
                    var i9Meta = info.i9_meta;
                    var w4Meta = info.w4_meta || {};
                    var docMeta = info.doc_last_meta || {};
                    var userInfo = info.user_info;

                    if (!_.isEmpty(docMeta)) {
                        res = self.getMismatchFields(i9Meta, w4Meta, docMeta, userInfo, false);
                        res.data = docMeta;
                        if (res.mismatch_fields_list.length > 0) {
                            for (var field of res.mismatch_fields_list) {
                                if (res.data.personal_information) {
                                    res.data.personal_information[field] = '';
                                }
                                if (res.data.candidate && res.data.candidate.first_name !== undefined && res.data.candidate.last_name !== undefined) {
                                    res.data.candidate[field] = '';
                                }
                            }
                        }

                        if (!_.isEmpty(res.data.candidate) && res.data.candidate.first_name !== undefined && res.data.candidate.last_name !== undefined && !_.isEmpty(res.data.personal_information)) {
                            res.data.personal_information = res.data.candidate;
                        }

                        if (!documentsCodeWithPhoneField.includes(documentCode) && res.data.personal_information && res.data.personal_information.phone) {
                            delete res.data.personal_information.phone;
                        }

                        if (!documentsCodeWithEmailField.includes(documentCode) && res.data.personal_information && res.data.personal_information.email) {
                            delete res.data.personal_information.email;
                        }

                    } else {
                        i9Meta = i9Meta && i9Meta.personal_information || {};
                        w4Meta = w4Meta && w4Meta.personal_information || {};
                        res.data = {};
                        res.data.personal_information = {};
                        var personalInfo = !_.isEmpty(i9Meta) ? i9Meta: w4Meta;
                        $.extend(res.data.personal_information, personalInfo);
                        res.data.personal_information.first_name = i9Meta.first_name || w4Meta.first_name || userInfo.first_name;
                        res.data.personal_information.last_name = i9Meta.last_name || w4Meta.last_name || userInfo.last_name;
                        res.data.personal_information.birthdate = i9Meta.birthdate || w4Meta.birthdate || userInfo.birth_date;
                        res.data.personal_information.email = i9Meta.email || w4Meta.email || userInfo.email;
                        res.data.personal_information.phone = i9Meta.phone || w4Meta.phone || (userInfo.phone && userInfo.phone.slice(-10));
                        res.data.personal_information.ssn = i9Meta.ssn || w4Meta.ssn;

                        if (!documentsCodeWithPhoneField.includes(documentCode) && res.data.personal_information && res.data.personal_information.phone) {
                            delete res.data.personal_information.phone;
                        }

                        if (!documentsCodeWithEmailField.includes(documentCode) && res.data.personal_information && res.data.personal_information.email) {
                            delete res.data.personal_information.email;
                        }
                    }
                    defer.resolve({
                        infoMeta: res,
                        i9Meta: info.i9_meta,
                        w4Meta: info.w4_meta
                    });
                });

            return defer.promise;
        };

        self.getProspectsWelcomeVideos = function () {
            var defer = $q.defer();
            OnBoardingAPI.getProspectsWelcomeVideos()
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                });
            return defer.promise;
        };
        self.getBrandDashboardStats = function (brands, includeArchived) {
            var brandIds = [];
            brands.forEach(function (brand) {
                if (brand.isManager) {
                    brandIds.push(brand.id);
                }
                if (brand.children) {
                    brand.children.forEach(function (childBrand) {
                        brandIds.push(childBrand.id);
                    });
                }
            });

            //get brand stats and assign it to brand
            DashboardAPI.getOnboardingStats(brandIds, includeArchived, 'active').then(function (statGroups) {
                statGroups.forEach(function (statGroup) {
                    var brand = self.findBrand(statGroup.brand_id, brands);
                    delete(statGroup.brand_id);
                    brand.stats = statGroup;
                });
            });
        };

        self.findBrand = function (brandId, brands) {
            for (var i in brands) {
                if (brands[i].id === brandId) {
                    return brands[i];
                }

                if (brands[i].children) {
                    for (var j in brands[i].children) {
                        if (brands[i].children[j].id === brandId) {
                            return brands[i].children[j];
                        }
                    }
                }
            }
        };

        // to open modal when click on view video button or if welcome video status not watched
        self.openWelcomeVideoViewModal = function (modalData, onHide) {
            hModalService.openModal({
                    component: 'welcome-video-view-modal',
                    cssClass: 'welcome-video-view-modal',
                    hideCloseButton: true,
                }, {
                    backdrop: 'static',
                    resolve: {
                        modalData: modalData
                    },
                    onHide: onHide
                }
            );
        }

        self.onEverfiyCloseModalHandler = function(res, code, scopes_ref, updateCardDocs) {
            const { user } = res;

            switch (code) {
                case 'RESEND_I9':
                    const objDoc = {
                        brand_id: res.brand_id,
                        candidate_fname: user.first_name,
                        candidate_lname: user.last_name,
                        cardId: user.cardId,
                        prospect_id: res.prospect_id,
                        candidate_id: user.id
                    };
                    updateCardDocs(objDoc);
                    break;

                case 'REDIRECT_TO_TRAINING':
                    if (hUser.isTopLevelContext()) {
                        const brandId = scopes_ref[0].speedySearchData.brand.id;
                        hRedirect(`/training/e-verify/index?brand_id=${brandId}`);
                    } else {
                        hRedirect("/training/e-verify/index");
                    }
                    break;

                case "SUCCESS":
                    if (scopes_ref[user.cardId]?.speedySearchData?.prospects) {
                        for (const prospect of scopes_ref[user.cardId].speedySearchData.prospects) {
                            if (prospect.id === res.prospect_id) {
                                const documents = prospect.documents || [];
                                for (const document of documents) {
                                    if (document.documentsList) {
                                        for (const i9Doc of document.documentsList) {
                                            if (i9Doc.id === res?.document_id && i9Doc?.everify_case_data?.everify_case) {
                                                const everifyNewCase = {
                                                    id: res.id,
                                                    cardId: user.cardId,
                                                    document_id: res.document_id,
                                                    job_id: res.job_id,
                                                    status: res.status,
                                                    sub_status: res.sub_status,
                                                    user_id: res.user_id
                                                };
                                                Object.assign(i9Doc.everify_case_data.everify_case, everifyNewCase);
                                                return;
                                            }
                                        }
                                    }
                                }
                                break;
                            }
                        }
                    }
                    break;
            }
        };
    }
})();
